<div class="btn-group w-100" role="group">
  <a
    *ngFor="let eventLink of eventFilterLinkProps$ | async"
    [routerLink]="[]"
    [queryParams]="{ view: eventLink.value, nav_id: navId }"
    floAnalytics
    [name]="eventLink.name"
    class="btn font-family-regular"
    data-test="event-filter-list-buttons"
    [class.active]="eventLink.active"
    >{{ eventLink.name }}</a
  >
</div>
<ol
  *ngIf="listItemProps$ | async as listItemsProps"
  class="row mx-0 ps-0 w-100"
>
  <flo-event-list-item
    *ngFor="let listItemProps of listItemsProps; trackBy: trackById"
    [props]="listItemProps"
    class="col-12 px-0"
  ></flo-event-list-item>
</ol>
<p
  *ngIf="emptyListText$ | async as textContent"
  [textContent]="textContent"
  class="headline text-500 text-center empty-text pt-5 pb-4 border-top"
></p>
